import { render, staticRenderFns } from "./RoomSelection.vue?vue&type=template&id=8b55178c&scoped=true&"
import script from "./RoomSelection.vue?vue&type=script&lang=js&"
export * from "./RoomSelection.vue?vue&type=script&lang=js&"
import style0 from "./RoomSelection.vue?vue&type=style&index=0&id=8b55178c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b55178c",
  null
  
)

export default component.exports